import Modal from "bootstrap/js/dist/modal";
import { useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import { useTranslation } from "react-i18next";
import { isFunction } from "utils/helpers";
import { default as AppointmentPatientsListSection } from "views/sections/AppointmentPatientsList";

const AppointmentPatient = ({ isShown, setShown, onConfirm }) => {
	const { t } = useTranslation();

	// portal dom element
	let portalsRoot = document.getElementById("portals") || null;
	if (!portalsRoot) {
		portalsRoot = document.createElement("div");
		portalsRoot.setAttribute("id", "portals");
		document.body.appendChild(portalsRoot);
	}

	// ref hook
	const modalRef = useRef(null);

	// effect hook
	useEffect(() => {
		const modalCurrentElement = modalRef?.current;
		let modal = Modal.getInstance(modalCurrentElement);
		if (!modal) {
			modal = new Modal(modalCurrentElement)[isShown ? "show" : "hide"]();
			modalCurrentElement?.addEventListener("hidden.bs.modal", () => setShown(false));
		} else {
			if (isShown) modal.show();
			if (!isShown) modal.hide();
		}
		return () => (modal ? Modal.getInstance(modalCurrentElement).dispose() : false);
	}, [isShown, setShown]);

	return (
		portalsRoot &&
		ReactDOM.createPortal(
			<div
				className="modal fade"
				ref={modalRef}
				id="appointmentPatientModal"
				tabIndex="-1"
				aria-labelledby="appointmentPatientModalLabel">
				<div className="modal-dialog modal-lg modal-dialog-centered">
					<div className="modal-content border-primary bg-primary-100">
						<div className="modal-header border-0 pb-0">
							<h5 className="modal-title w-100 text-capitalize mb-0" id="appointmentPatientModalLabel">
								<small>
									<strong>Patient Search</strong>
								</small>
							</h5>
							<button
								type="button"
								className="btn-close ms-auto"
								data-bs-dismiss="modal"
								aria-label={t("actions.close")}></button>
						</div>
						<div className="modal-body">
							{isShown && (
								<AppointmentPatientsListSection
									onSelect={(patient) => {
										if (modalRef?.current) {
											modalRef.current?.addEventListener(
												"hide.bs.modal",
												() => isFunction(onConfirm) && onConfirm(patient),
												{ once: true }
											);
											Modal.getInstance(modalRef.current)?.hide();
										}
									}}
								/>
							)}
						</div>
					</div>
				</div>
			</div>,
			portalsRoot
		)
	);
};

export default AppointmentPatient;
